<template>
  <div>

    <template>
      <!--<div class="title_text">秀场介绍</div>-->
      <!--      <h4>秀场介绍</h4>-->
      <div class="title_content">
        <div :class="['basic', brand_delivery_no_show?'fense':'']">
          <div class="basic_box">
            <img class="basic_img" src="../assets/fasong.png">
            <span>品牌方已寄出合同</span>
          </div>

        </div>
        <div :class="['basic', host_no_show?'zise':'' ]">
          <div class="basic_box">
            <img class="basic_img" src="../assets/fasong.png">
            <span>组委会已寄出合同</span>
          </div>
        </div>
        <div :class="['basic', (host_no_show&&brand_delivery_no_show)?'chengse':'']">
          <div class="basic_box">
            <img class="basic_img" src="../assets/shoudao.png">
            <span>合同签署完成</span>
          </div>
        </div>
      </div>
      <div class="line_"></div>
<!--      <h4 style="margin-bottom: 20px">请下载组委会信息，按要求寄出合同</h4>-->
      <h4 style="margin-bottom: 20px">查看组委会信息，按要求寄出合同</h4>

      <el-form :model="formData" :rules="formData_rules" ref="formDataRef">
<!--        <el-row :gutter="24">-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="联系人:" prop="brand_contacts">-->
<!--              <el-input type="text" v-model="formData.brand_contacts" auto-complete="off"-->
<!--                        placeholder="请输入联系人"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="联系电话:" prop="brand_mobile">-->
<!--              <el-input type="text" v-model="formData.brand_mobile" auto-complete="off"-->
<!--                        placeholder="请输入联系电话"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->

<!--        </el-row>-->
        <el-row :gutter="24">
<!--          <el-col :span="8">-->
<!--            &lt;!&ndash; <div style="color:#666666">意愿一</div>&ndash;&gt;-->
<!--            <el-form-item label="详细地址:" prop="brand_address">-->
<!--              <el-input maxlength="100"-->
<!--                        show-word-limit-->
<!--                        v-model="formData.brand_address"-->
<!--                        type="textarea"-->
<!--                        rows="4"-->
<!--                        clearable placeholder="请输入详细地址"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="8">
            <div class="downloadBox">
              <div class="downloadLeft">
<!--                <img class="pdfIcon" src="../assets/pdf.jpg" alt="">-->
<!--                <div class="unitRight">-->
<!--                  <div class="unittitle">组委会信息.pdf</div>-->
<!--                </div>-->
                组委会地址：北京市朝阳区酒仙桥路2号798·751园区中央大厅二层，组委会 13811251531
              </div>
<!--              <button class="downloadIcon" @click="down">下载</button>-->
            </div>
          </el-col>
        </el-row>
<!--        <div style="margin-top: 10px;">-->
<!--          <button class="btn_ " @click="save">保存信息</button>-->
<!--        </div>-->

      </el-form>
      <div class="footer" style="margin-top: 100px;">
<!--        v-if="!brand_delivery_no_show"-->
        <button  v-if="!brand_delivery_no_show&&brand_delivery_no_show!=null" class="btn next_btn" @click="courier_show=true">已寄出合同点击确认</button>
        <button  v-if="!brand_delivery_no_show&&brand_delivery_no_show!=null" class="btn_" @click="next">下一步</button>
        <button  v-else class="btn_" @click="to_next">下一步</button>
      </div>
    </template>

    <el-dialog
        :close-on-click-modal="false"
        title="快递单号"
        :visible.sync="courier_show"
        width="480px"
    >
      <el-input type="text" v-model="formData.brand_delivery_no" auto-complete="off"
                placeholder="请输入快递单号"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="save_courier" size="medium">确定</el-button>
  </span>
    </el-dialog>
  </div>


</template>

<script>
import {
 declareOrder_detail,
  MembersDetail,
 orderConfirm, saveDeliveryNo, saveMail
} from "@/api/api";

export default {
  components: {},
  props: [],
  name: "contractConfirmation",
  data() {
    return {
      brand_delivery_no_show: null,
      host_no_show: false,
      courier_show: false,
      to_examine_form: {//
        // 1待审核  2成功  3驳回
        audit_status: 2, //审核状态
        review_text1: "请等待审核",//待审核文案
        review_text2: "已确认",//成功文案
        review_text3: "已驳回",//驳回文案
      },
      cascader_props: {label: 'name', value: 'id', children: 'site_time'},
      formData: {
        wish_1: [],
        price_1: 0,
        wish_2: [],
        price_2: 0,
        wish_3: [],
        price_3: 0,
      },//
      change_content: 1,
      headers: {
        token: localStorage.getItem("token")
      },

      form_data: {},
      typeList: [{
        id: '1',
        name: '个人委员会'
      }, {
        id: '2',
        name: '单位委员会'
      }],
      MemberLevelList: [],
      isigned: "",
      checked: true,


      status: 1,

      active: 10,
      busactive: 10,
      page_no: 1,
      page_size: 10,
      total: 100,
      stepsList: [
        {title: '登记'},
        {title: '完善资料'},
        {title: '承诺书'},
        {title: '等待审核'},
        {title: '完成缴费'}
      ],
      tabList: [],
      formData_rules: {
        brand_contacts: [
          {required: true, message: '请输入', trigger: ['blur']},
        ],
        brand_mobile: [
          {required: true, message: '请输入', trigger: ['blur']},
        ],
        brand_address: [
          {required: true, message: '请输入', trigger: ['blur']},
        ],
      },


      activeName: 'basic',
      loading: false,
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      mark: '',
      options: [],
      Order_detail: {}
    };
  },
  mounted() {
    this.init()
  },
  created() {


  },
  watch: {},
  methods: {
    async init() {
      let data = this.$qs.stringify({
        declare_items_id: JSON.parse(localStorage.getItem('theSession')).id,
      });
      const res = await declareOrder_detail(data)
      this.formData = res.data
      this.brand_delivery_no_show=!!res.data.brand_delivery_no && res.data.brand_delivery_no !== ""
      this.host_no_show= !!res.data.host_no && res.data.host_no !== ""
    },
    // 赵
    async next() {
      // this.$refs['formDataRef'].validate(async (valid) => {
      //   if (valid) {
          if (this.formData.brand_delivery_no != '') {
            let data = {
              order_no: this.formData.order_no,
            }
            const res = await orderConfirm(data)
            if (res.code == 1) {
              this.$message.success(res.msg);
              // this.$parent.to_next()
              location.reload();
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.warning('请确认已经寄出合同');

          }
      //   }
      // })

    },
    to_next(){
      this.$parent.to_next()
    },
    change_contentShow() {
      this.change_content = 2
    },
    save() {
      this.$refs['formDataRef'].validate((valid) => {
        if (valid) {
          let data = this.formData
          saveMail(data).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
            }
          })
        }
      })

    },
    // 保存快递单号
    async save_courier() {
      let data = {
        declare_items_id: JSON.parse(localStorage.getItem('theSession')).id,
        brand_delivery_no: this.formData.brand_delivery_no
      }
      const res = await saveDeliveryNo(data)
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.courier_show = false

        this.init()

      }

    },


    edit_disabled(ref) {
      this.$refs[ref].change_form_disabled()
    },


    // 下载
    down() {
      let file = 'https://oss.indata3.com/cfa/uploads/DeclareUp/PDF/organize.pdf'
      window.open(file, '_blank');
    }, //


  },
}
;
</script>

<style lang="scss" scoped>
.title_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.title_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.basic {
  width: 30%;
  max-width: 440px;
  height: 108px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #666666;
}

.basic_A {

}

.fense {
  background: #FD0054;
}

.zise {
  background: #7A08FA;
}

.chengse {
  background: #FF5722;
}

.basic_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
  color: #ffffff;
}

.basic_img {
  width: 44px;
  margin-right: 10px;
}

.line_ {
  border: 3px solid #F3F3F3;
  margin: 20px 0;
}

/deep/ .el-form-item__content {
  width: 80%;
}

/deep/ .el-cascader {
  width: 100%;
}

/deep/ .el-row {
  display: flex;
  align-items: center;
}

.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.unitTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7F8FA4;
  margin: 30px 0 10px;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status0 {
  background: rgba(102, 102, 102, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #FAAD14;
}

.status2 {
  background: rgba(82, 196, 26, 0.1);
  color: #52C41A;
}

.status3 {
  background: rgba(255, 77, 79, 0.1);
  color: #FF0000;
}


.changecolor {
  cursor: pointer;

  /deep/ .el-step__line {
    background-color: rgba(228, 0, 128, 0.40);
  }

  /deep/ .el-step__head.is-wait {
    border-color: rgba(228, 0, 128, 0.40);
    color: rgba(228, 0, 128, 0.40);
  }

  /deep/ .el-step__title.is-wait {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(228, 0, 128, 0.40);
  }

}

// zhao 步骤条样式修改
.stepBox {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;

  .go-back {
    position: absolute;
    left: 0;
    top: 0;

  }

  /deep/ .el-step.is-center .el-step__line {
    left: 68%;
    right: -22%;
  }

  /deep/ .el-step__icon {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }

  ///deep/ .el-step__head.is-wait {
  //  color: #C7C7CC;
  //  border-color: #C7C7CC;
  //}

  /deep/ .el-step__head.is-process {
    border-color: #E40080;
    color: #E40080;

    .el-step__line {
      background: #E40080;
    }
  }

  /deep/ .el-step__head.is-finish {
    border-color: rgba(228, 0, 128, 0.40);
    color: rgba(228, 0, 128, 0.40);

    .el-step__line {
      background: rgba(228, 0, 128, 0.40);
    }
  }

  /deep/ .el-step__title.is-finish {
    color: rgba(228, 0, 128, 0.40);
    font-size: 12px;
  }

  ///deep/ .el-step__title.is-wait {
  //  font-family: PingFangSC, PingFang SC;
  //  font-weight: 400;
  //  font-size: 12px;
  //  color: #8E8E93;
  //}

  /deep/ .el-step__title.is-process {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #E40080;
  }

}

// zhao 步骤条盒子
.stepsItem {
  width: 692px !important;
}

.downloadBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 383px;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid #CAD2DD;
}

.downloadLeft {
  display: flex;
}

.pdfIcon {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}

.unitRight {
  margin-left: 20px;

  .unittitle {
    line-height: 68px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #2C2C2E;
  }

  .unittimes {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 15px 0;
  }

  .unitnum {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
  }

}

.downloadIcon {
  cursor: pointer;
  width: 60px;
  height: 26px;
  background: #E40080;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #FFFFFF;
  border: none;
}

// zhao 基本信息表单盒子
.informationFormBox {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bus-to_examine_form {
    width: 560px !important;

    /deep/ .el-select {
      width: 400px;
    }
  }

  .next {
    margin-top: 190px;
  }
}

.apply-phone {
  /deep/ .el-input__inner {
    width: 400px;
    height: 36px;
    border: 1px solid #CAD2DD;
  }
}

.formBox {
  //height: 650px;
  //overflow: auto;

}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.QR_box {
  text-align: center;
}

.QR_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}

.checkboxBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 94px;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}


.tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.searchBtnBox {
  margin-bottom: 20px
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.selitem {
  width: 100%;
}

// 完成缴费
.completePaymentBox {
  width: 880px;
  background: #FFFFFF;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  margin: 20px auto 0;
  padding: 30px 20px 66px;
  box-sizing: border-box;

  .completePaymentTips {
    width: 252px;
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1D1D1D;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .completePaymentLine {
    width: 100%;
    height: 1px;
    background: #EEEEEE;
  }

  .payInfoBox {
    display: flex;
    align-items: center;
    margin: 13px 0;

    .left {
      span {
        display: inline-block;
      }

      span:nth-child(1) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #1D1D1D;
      }

      span:nth-child(2) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #FF4D4F;
      }
    }

    .right {
      margin-left: 185px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #555555;

      .rightInfo {
        display: flex;
        margin: 10px 0;

        .rightItem {
          margin-right: 70px;
        }
      }
    }
  }

  .paytitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #1D1D1D;
    margin-top: 10px
  }

  .upload-demo {
    margin-left: 26px;
    display: flex;
    margin-top: 17px;
  }

  /deep/ .el-upload-list__item {
    margin-top: 0;
  }

  .changepay {
    display: flex;
    align-items: flex-start;
  }

  .wyjf {
    margin-top: 39px;
  }

  .radioItem {
    display: inline-block;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    margin-top: 9px;

    .radioIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 3px;
    }
  }

  .codeBox {
    display: flex;
    width: 345px;
    height: 116px;
    padding: 7px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #DEDEDE;
    margin-top: 20px;

    .code {
      width: 102px;
      height: 102px;
    }

    .codeinfo {
      margin-left: 10px;

      .info1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
      }

      .info2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #FF4D4F;
        margin-top: 10px;
      }

      .info3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-top: 16px;
      }
    }

  }

}

.upload-btn {
  width: 61px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #FFFFFF;
}

.search-btn:hover {
  background: #E40080;
}

.search-btn:active {
  background: #E40080;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }

}

.personageCommitment {
  padding-top: 30px;
  width: 100%;
  height: 490px;
  background: #F2F6FB;
}

.unitCommitment {
  width: 100%;
  height: 490px;
}

.downloadBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 383px;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid #CAD2DD;
}

.downloadLeft {
  display: flex;
}

.downloadIcon {
  cursor: pointer;
  width: 60px;
  height: 26px;
  background: #E40080;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #FFFFFF;
  border: none;
}

.pdfIcon {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}

.unitRight {
  margin-left: 20px;

  .unittitle {
    line-height: 68px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #2C2C2E;
  }

  .unittimes {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 15px 0;
  }

  .unitnum {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
  }

}

.poster {
  width: 100%;
  display: block;
  margin-top: 50px;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

</style>

